module.exports = __webpack_public_path__ + "static/special-olympics-logo-f88f656fd08165b63d654ff9aabdf52a.svg";